/**
 * @flow
 * @relayHash ce93333f6ac165abf10fc26910fd23c3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type GpxMediaList_gpxFileMedia$ref = any;
export type GpxMediaListPaginationQueryVariables = {|
  eventId: string,
  gpxFileId: string,
  count: number,
  cursor?: ?string,
  isRecheckPage: boolean,
|};
export type GpxMediaListPaginationQueryResponse = {|
  +viewer: ?{|
    +event: ?{|
      +searchMediaByGpx: ?{|
        +$fragmentRefs: GpxMediaList_gpxFileMedia$ref
      |}
    |}
  |}
|};
export type GpxMediaListPaginationQuery = {|
  variables: GpxMediaListPaginationQueryVariables,
  response: GpxMediaListPaginationQueryResponse,
|};
*/


/*
query GpxMediaListPaginationQuery(
  $eventId: ID!
  $gpxFileId: ID!
  $count: Int!
  $cursor: String
  $isRecheckPage: Boolean!
) {
  viewer {
    event(id: $eventId) {
      searchMediaByGpx(gpxFileId: $gpxFileId) {
        ...GpxMediaList_gpxFileMedia
      }
      id
    }
    id
  }
}

fragment GpxMediaList_gpxFileMedia on ExtendedMediaConnection {
  mediaList(first: $count, after: $cursor) {
    edges {
      node {
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    ...MediaList_media
  }
}

fragment MediaListItem_item on Media {
  id
  sgId
  name
  shotDate
  variants {
    name
    url
    id
  }
}

fragment MediaList_media on MediaConnection {
  edges {
    node {
      id
      sgId
      shotDate
      variants {
        name
        url
        id
      }
      recheckStatus @include(if: $isRecheckPage)
  recheckRequestedAt @include(if: $isRecheckPage)
      ...MediaListItem_item
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "eventId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "gpxFileId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isRecheckPage",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "eventId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "gpxFileId",
    "variableName": "gpxFileId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GpxMediaListPaginationQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Event",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "searchMediaByGpx",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "ExtendedMediaConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "GpxMediaList_gpxFileMedia",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "GpxMediaListPaginationQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Event",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "searchMediaByGpx",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "ExtendedMediaConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaList",
                    "storageKey": null,
                    "args": (v3/*: any*/),
                    "concreteType": "MediaConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MediaEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Media",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "__typename",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "sgId",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "shotDate",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "variants",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MediaFile",
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ]
                              },
                              (v5/*: any*/),
                              {
                                "kind": "Condition",
                                "passingValue": true,
                                "condition": "isRecheckPage",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "recheckStatus",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "recheckRequestedAt",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "cursor",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasNextPage",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "endCursor",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "mediaList",
                    "args": (v3/*: any*/),
                    "handle": "connection",
                    "key": "GpxMediaList_mediaList",
                    "filters": null
                  }
                ]
              },
              (v4/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "GpxMediaListPaginationQuery",
    "id": null,
    "text": "query GpxMediaListPaginationQuery(\n  $eventId: ID!\n  $gpxFileId: ID!\n  $count: Int!\n  $cursor: String\n  $isRecheckPage: Boolean!\n) {\n  viewer {\n    event(id: $eventId) {\n      searchMediaByGpx(gpxFileId: $gpxFileId) {\n        ...GpxMediaList_gpxFileMedia\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment GpxMediaList_gpxFileMedia on ExtendedMediaConnection {\n  mediaList(first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    ...MediaList_media\n  }\n}\n\nfragment MediaListItem_item on Media {\n  id\n  sgId\n  name\n  shotDate\n  variants {\n    name\n    url\n    id\n  }\n}\n\nfragment MediaList_media on MediaConnection {\n  edges {\n    node {\n      id\n      sgId\n      shotDate\n      variants {\n        name\n        url\n        id\n      }\n      recheckStatus @include(if: $isRecheckPage)\n  recheckRequestedAt @include(if: $isRecheckPage)\n      ...MediaListItem_item\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ec5921a16a3fb65a6e9462999541e2b8';

module.exports = node;
